export default "__VITE_ASSET__CghOwDBh__"